import "./style.scss";

import { Avatar, Tooltip } from "@mui/material";
import { PortalType } from "contexts/portal.context";
import { forwardRef, useContext } from "react";
import { useTranslation } from "react-i18next";

import variables from "../../../assets/styles/_variables.module.scss";

interface PublicationListItemProps {
    element: any;
    currentElementId: number;
    index: number;
    action: (element: any) => void;
    disabled?: boolean;
}

const PublicationListItem = forwardRef<HTMLDivElement, PublicationListItemProps>(function PublicationListItem(
    { element, currentElementId, index, action, disabled }: PublicationListItemProps,
    ref,
) {
    const { t } = useTranslation();
    const portalType = useContext(PortalType);

    return (
        <div
            className="publication-list-item"
            style={disabled ? { opacity: 0.1, pointerEvents: "none" } : {}}
            key={`${element.id}_${index}`}
            ref={ref}
        >
            <div onClick={() => action(element)}>
                <div className={`publications-list-element${element.id === currentElementId ? " active" : ""}`}>
                    <div className="avatar-block" style={{ display: "flex", alignItems: "stretch", gap: "10px" }}>
                        <Avatar
                            variant="rounded"
                            src={element.avatarUrl}
                            imgProps={{ sx: { objectFit: "cover" } }}
                            sx={{
                                backgroundColor: "#FFF2F1",
                                // backgroundColor: element.background,
                                color: variables["foreground"],
                                fontSize: "14px",
                                height: "50px",
                            }}
                        >
                            {element.name.slice(0, 1)}
                        </Avatar>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <div className="publications-list-element-tags">
                                {element.tags && (
                                    <>
                                        {element.tags
                                            .slice(0)
                                            .reverse()
                                            .map((item: any, i: number) => {
                                                return i < 15 ? (
                                                    <Tooltip key={`tooltip-${item.id}`} title={item.name} arrow>
                                                        <span
                                                            className={`publications-list-element-tag-${item.color}`}
                                                            key={item.id}
                                                        ></span>
                                                    </Tooltip>
                                                ) : null;
                                            })}
                                    </>
                                )}
                                <span className={`elements-list-element-tag`}></span>
                            </div>
                            <span title={element.name} className="publication-list-title-name">
                                {element.name}
                            </span>
                            <span style={{ fontSize: "12px", color: "#575757" }}>
                                {t(`PressAudio.CountArticles_${portalType}`, { count: element.nbArticles ?? 0 })}
                            </span>
                        </div>
                    </div>
                    {/* <div className="date-block">
                        {element.releaseDate ? format(new Date(element.releaseDate), "d MMM") : ''}
                    </div> */}
                    <div className="publications-list-element-date">
                        {element.accountStatus === "confirmed" && (
                            <div className="confirmed">
                                <span className="hovered-status">TEST</span>
                            </div>
                        )}
                        {element.accountStatus === "pending" && (
                            <div className="pending">
                                <span className="hovered-status">TEST</span>
                            </div>
                        )}
                        {element.accountStatus === "noaccount" && (
                            <div className="noaccount">
                                <span className="hovered-status">TEST</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default PublicationListItem;
